/* eslint-disable eol-last */
export default {
    namespaced: true,
    state: {
        provider_id: '',
        username: '',
        loggedIn: false,
        profile: '',
        userid: '',
        school: []
    },

    actions: {
        unSetProviderCode: ({ commit }) => {
                commit('UNSET_PROVIDER_CODE')
            }

    },

    getters: {
        isLoggedIn: (state) => state.loggedIn
    },

    mutations: {
        UNSET_PROVIDER_CODE(state) {
            state.provider_id = ""
            state.loggedIn = false
        },
        setProviderDetails: (state, payload) => {
            state.provider_id = payload.sz_providerid || state.provider_id
            state.username = payload.szusername || state.username
            state.profile = payload.szprofile || state.profile
            state.userid = payload.szuserid || state.userid
            state.profile = payload.profile || state.profile
            state.szreqauth = payload.szreqauth || state.szreqauth
            state.usertype = payload.usertype || state.usertype
        },
        setLoggedIn: (state, loggedIn) => {
            state.loggedIn = loggedIn
        },
        selectSchool: (state, payload) => {
            state.school = payload
        },
        setProviderId: (state, providerid) => {
            state.provider_id = providerid || state.provider_id

        }
    }
}